import 'src/polyfills/array-prototype-at'

import 'src/flp/stickyHeader'
import 'src/flp/dialogModals'
import 'src/flp/openModalHandlers'
import 'src/flp/reactions'

import mountReactApp from 'src/utils/mountReactApp'
import App from 'src/flp/App'

mountReactApp(App)
